<div class="searchbar search-location"
     [ngClass]="{'opened': isMobileOverlayOpened, 'address': suggestionsType === SuggestionsType.ADDRESS, 'district': suggestionsType === SuggestionsType.DISTRICT}"
     (focusout)="onFocusOutMain($event)"
     #mainEl >
  <div class="searchbar__input-wrapper" (click)="showDistrictsWhenDisabled()">
    <input class="searchbar__input"
           type="text"
           placeholder="Nach Ort suchen"
           #searchEl
           enterkeyhint="go"
           [(ngModel)]="searchValue"
           (ngModelChange)="debouncedSearchValueUpdateTrigger()"
           (focusin)="onFocusIn()"
           (focusout)="onFocusOut()"
           (keyup)="onInputKeyUp($event)"
           [disabled]="typeDisabled"
           [ngClass]="{'searchbar__input--active': storeSearchValue.length || savedDistricts.length, 'type-disabled': typeDisabled}"

    >

    <div class="searchbar__icon searchbar__icon--left searchbar__icon--search">
      <brt-icon [icon]="'location-pin'"></brt-icon>
    </div>

    <button role="button" class="searchbar__icon searchbar__icon--right searchbar__icon--submit" *ngIf="actionIconType === 'submit'" (click)="submitAddressSearch()">
      <brt-icon [icon]="'bold-arrow-right-circle'"></brt-icon>
    </button>

    <button role="button" class="searchbar__icon searchbar__icon--right searchbar__icon--clear" *ngIf="actionIconType === 'clear'" (click)="onClearIconClicked($event)">
      <brt-icon [icon]="'x-reg-circle'"></brt-icon>
    </button>

<!--    <div class="searchbar__suggestions-closer" *ngIf="suggestionModalOpen" (click)="closeSuggestionModal()"></div>-->


  </div>

  <div class="searchbar__suggestions searchbar__suggestions--frequently" [attr.inert]="suggestionsType === SuggestionsType.DISTRICT ? null : ''">
    <brt-search-location-filter (value-changed)="districtsValueChanged($event)" (save)="filterByDistricts($event)" (userLocationChanged)="setUserLocation($event)" [entity]="currentEntity" #slFilter></brt-search-location-filter>
  </div>

  <div class="searchbar__suggestions searchbar__suggestions--similar" [attr.inert]="suggestionsType === SuggestionsType.ADDRESS ? null : ''">
    <ng-container *ngIf="proposedPlaces.length > 0; else nothingFound">
      <button role="button" class="searchbar__suggestions-similar-value" *ngFor="let item of proposedPlaces" (click)="onSimilarItemClicked(item);">
        <div class="searchbar__suggestions-similar-value-icon"><brt-icon [icon]="'search'"></brt-icon></div>
        <div class="searchbar__suggestions-similar-value-text" [innerHTML]="item.name"></div>
      </button>
    </ng-container>
    <ng-template #nothingFound>
      <div class="searchbar__suggestions-similar-not-found" *ngIf="searchValue.length > 0 && !googleApiLoading">Nichts gefunden!</div>
      <div class="searchbar__suggestions-similar-not-found" *ngIf="googleApiLoading">Wird geladen...</div>
    </ng-template>

  </div>

  <div class="search-location__mobile-part">
    <brt-search-location-filter (value-changed)="districtsValueChanged($event)" (save)="filterByDistricts($event)" [entity]="currentEntity" #slFilter></brt-search-location-filter>
  </div>
</div>
